import React, { FC } from 'react'
import { Typography } from '@mui/material'
import { Button } from '@components/ui'
import HelpIcon from '@assets/images/svg/ico-question.svg'
import Link from 'next/link'

interface Props {
  help: string
  action: string
  ctaLabel: string
  ctaTarget: string
}

const Footer: FC<Props> = ({ help, action, ctaLabel, ctaTarget }) => {
  return (
    <>
      <div className="flex h-[200px] flex-col items-center justify-between rounded bg-super-ya-blue7 px-[20px] py-[20px] sm:px-[95px] md:w-[540px]">
        <div className="mb-[14px]">
          <HelpIcon />
        </div>
        <Typography color="textPrimary" className="mb-[26px] flex flex-col">
          <span className="text-center font-semibold">{help}</span>
          <span className="text-center font-bold">{action}</span>
        </Typography>
        <Link href={ctaTarget} passHref={true}>
          <Button
            variant="outlined"
            style={{
              backgroundColor: 'white'
            }}
            color="primary"
            className="h-[50px] max-w-[350px] rounded text-base font-semibold normal-case"
          >
            {ctaLabel}
          </Button>
        </Link>
      </div>
    </>
  )
}

export default Footer
